export const healthData = [
  {
    id: 1,
    organ: 'Lungs',
    icon: '🫁',
    date: '24 Oct 2021',
    status: 'good', 
    bgColor: 'bg-[#f6faff]',
    iconBg: 'bg-red-100',
    progressColor: 'bg-red-500'
  },
  {
    id: 2,
    organ: 'Teeth',
    icon: '🦷',
    date: '24 Oct 2021',
    status: 'good', // green
    bgColor: 'bg-[#f6faff]',
    iconBg: 'bg-green-100',
    progressColor: 'bg-green-600'
  },
  {
    id: 3,
    organ: 'Bone',
    icon: '🦴',
    date: '24 Oct 2021',
    status: 'good',
    bgColor: 'bg-[#f6faff]',
    iconBg: 'bg-orange-100',
    progressColor: 'bg-orange-500'
  }
]